module.exports = "pegasus/assets/film-card.png";